import rdUI from '@rd/rd-ui';
import rdBtnGroup from '@/components/businessUI/rdBtnGroup';

export default {
	RdText: rdUI.RdText,
	rdBtnGroup: rdBtnGroup,
};
